import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=3272bcc4&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=3272bcc4&prod&lang=css"
import style1 from "./Information.vue?vue&type=style&index=1&id=3272bcc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272bcc4",
  null
  
)

export default component.exports